module.exports = __webpack_public_path__ + "img/extension.bc805564.jpg";